import type { MiddlewareFunction } from 'react-router';

import { getRouteFromWindow, routerState } from '@trello/router';

/**
 * Update the {@link routerState} when react-router navigates to a new route.
 */
export const routerStateMiddleware: MiddlewareFunction = async (
  _args,
  next,
): Promise<void> => {
  await next();

  routerState.setValue(getRouteFromWindow());
};
